import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { GetUsersBirthdaysResponseItemDto } from '@src/api';

@Component({
  selector: 'new-list-item-birthdays-user',
  templateUrl: './list-item-birthdays-user.component.html',
  styleUrls: ['../styles/list-item.component.scss', './list-item-birthdays-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemBirthdaysUserComponent {
  @Input() user: GetUsersBirthdaysResponseItemDto = {};

  /** Шаблон для отображения даты рождения */
  @Input() birthDateContent?: TemplateRef<any>; // TODO: избавиться от any, был тип GetUsersBirthdaysResponseItemDto. Возможно указан неверно
}
